"use client";

import { useNavigation } from "react-router-dom";

/**
 * A page's code is loaded when the page is first visited (2.713), so there is
 * a moment before it can render. That moment is said, not left blank, and said
 * to assistive technology too: a polite status, so a screen reader announces
 * the wait without interrupting.
 */
export function PageLoading() {
  return (
    <div role="status" aria-live="polite" className="flex min-h-[40vh] items-center justify-center text-sm text-muted-foreground">
      Loading page…
    </div>
  );
}

/**
 * While a navigation loads the next page's code, the current page stays on
 * screen (React Router keeps it until the next is ready). This says the
 * navigation is under way, so a click that has not visibly done anything yet is
 * not mistaken for one that did nothing. The region is always present so its
 * announcement is heard when the text arrives.
 */
export function NavigationStatus() {
  const navigation = useNavigation();
  const loading = navigation.state === "loading";
  return (
    <div role="status" aria-live="polite" className="sr-only" data-testid="navigation-status">
      {loading ? "Loading page…" : ""}
    </div>
  );
}
